import { defaultStatus } from "../defaultState/defaultState";
import {
  CLEAR_PROFILE,
  FETCH_PROFILE_FAILURE,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS
} from "./profileType";

const initialState = {
 
  fetchProfile: { ...defaultStatus },
  updateProfile: { ...defaultStatus },

};

const ProfileReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_PROFILE_REQUEST:
      const {ProfileId}=payload
      return {
        ...state,
        fetchProfile: { ...state.fetchProfile, inProgress: true ,ProfileId},
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        fetchProfile: { ...state.fetchProfile, success: true, inProgress: false,data: payload?.Profiles },
        
      };
    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        fetchProfile: {
          ...state.fetchProfile,
          error: true,
          errorMessage: payload.error,
        },
      };
    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateProfile: { ...state.updateProfile, inProgress: true },
      };
    case UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        updateProfile: {
          ...state.updateProfile,
          inProgress: false,
          success: true,
          data: payload?.Profile
        },
      };
    }
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        updateProfile: {
          ...state.updateProfile,
          error: true,
          inProgress: false,
          success: false,
          errorMessage: payload.error || payload?.errorMessage || null, 
          errorFields: payload?.errorFields || null,
        },
      };
      case CLEAR_PROFILE:
        return { ...defaultStatus }


    default:
      return state;
  }
};

export default ProfileReducer;